import { WindowedTable } from '@economic/taco';
import React from 'react';
import { Trans, t } from '@lingui/macro';

import { SalesDocument } from '../../types';
import date from '../../../../../shared/util/utilities/date';
import number from '../../../../../shared/util/utilities/number';

interface Props {
    selectedOrders: SalesDocument[];
    handleRemoveOrder: (number: number) => void;
}
export default function SelectedOrdersTable({ selectedOrders, handleRemoveOrder }: Props) {
    return (
        <div className=" overflow-hidden border border-grey-300 rounded-md" style={{ height: '243px' }}>
            <WindowedTable<SalesDocument>
                className="h-full"
                data={selectedOrders}
                actions={[
                    {
                        showOnRow: true,
                        icon: 'close',
                        text: t`Remove`,
                        onClick: row => handleRemoveOrder(row.values.number),
                        tooltip: t`Remove`,
                    },
                ]}
                emptyStateRenderer={() => (
                    <div className="flex justify-center mt-4">
                        <Trans>No orders selected</Trans>
                    </div>
                )}>
                <WindowedTable.Column<SalesDocument> accessor="number" headRenderer={t`No.`} align="left" />
                <WindowedTable.Column<SalesDocument>
                    accessor="date"
                    headRenderer={t`Date`}
                    align="left"
                    cellRenderer={({ value }) => date.format(date.parseFromISOString(value))}
                />
                <WindowedTable.Column<SalesDocument> accessor="customerName" headRenderer={t`Customer name`} align="left" />
                <WindowedTable.Column<SalesDocument>
                    accessor="amount"
                    headRenderer={t`Net amount`}
                    align="right"
                    cellRenderer={({ value }) => number.format(value)}
                />
            </WindowedTable>
        </div>
    );
}
